<template>
  <v-container fluid>
    <div ref="lgContainer" style="display:none"></div>
    <v-dialog
      v-model="new_weld_dialog"
      fullscreen
      hide-overlay
      persistent
      no-click-animation
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-container class="container--app pa-0">
          <v-form ref="weldForm" class="d-flex flex-grow-1">
            <v-row>
              <v-col cols="12" class="d-flex flex-row align-center justify-space-between">
                <span>{{$t('message.advancedWeldLog.updateWeldLog')}}</span>
                <v-btn
                  icon
                  @click="closeDialog"
                >
                  <v-icon :color="$vuetify.theme.dark ? 'white' : 'black'">mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" class="d-flex flex-row flex-wrap pa-0">
                <v-col cols="6" lg="4">
                  <v-text-field readonly outlined dense hide-details :label="$t('message.advancedWeldLog.projectName')"
                                :value="drawing.project.project_name"></v-text-field>
                </v-col>
                <v-col cols="6" lg="4">
                  <v-text-field readonly outlined dense hide-details :label="$t('message.advancedWeldLog.poRanked')"
                                :value="drawing.project.po_ranked"></v-text-field>
                </v-col>
                <v-col cols="6" lg="4">
                  <v-text-field readonly outlined dense hide-details :label="$t('message.advancedWeldLog.aoRanked')"
                                :value="drawing.project.ao_ranked"></v-text-field>
                </v-col>
                <v-col cols="6" lg="4">
                  <v-text-field readonly outlined dense hide-details :label="$t('message.projectFeature.NDTSpecifications')"
                                :value="computedNdtSpecification"></v-text-field>
                </v-col>
              </v-col>
              <v-col cols="12" class="pa-0 py-2">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" class="d-flex flex-row flex-wrap pa-0">
                <v-col cols="6" lg="4">
                  <v-text-field disabled dense hide-details type="text" small
                                :label="$t('message.advancedWeldLog.weldNo')"
                                outlined
                                v-model="weld_row.weld_nr"></v-text-field>
                </v-col>
                <v-col cols="6" lg="4">
                  <v-select disabled clearable :items="drawing.project.wpqr"
                            item-text="document_type"
                            return-object dense
                            hide-details outlined :label="$t('message.advancedWeldLog.wps')" :value="weld_row.wps_nr">
                  </v-select>
                </v-col>
                <v-col cols="6" lg="4">
                  <v-text-field disabled hide-details type="text" dense
                                :label="$t('message.advancedWeldLog.weldingConsumables')"
                                outlined
                                v-model="weld_row.filler_materials"></v-text-field>
                </v-col>
                <v-col cols="6" lg="4">
                  <v-text-field hide-details type="text" dense :label="$t('message.advancedWeldLog.batchNumber')"
                                outlined
                                v-model="weld_row.charge_nr"></v-text-field>
                </v-col>
                <v-col cols="6" lg="4">
                  <v-select multiple :items="expertise" item-text="text" item-value="expertise_id" dense hide-details="auto" outlined :label="$t('message.advancedWeldLog.welderCertificates')"
                            v-model="weld_row.weldlog_expertise_id"
                            :rules="[val => !weld_row.weld_end || (val && val.length > 0) || $t('message.advancedWeldLog.certificateRequiredWhenWeldEnd')]">
                    <template #selection="{ item, index }">
                      <span class="v-select__selection v-select__selection--comma" v-if="index === 0">{{ item.text }}</span>
                    </template>
                    <template #prepend-item>
                     <v-col cols="12">
                       <v-text-field
                         v-model="expertiseSearch"
                         label="Search"
                         append-icon="mdi-magnify"
                         dense
                         outlined
                         hide-details
                         clearable
                       ></v-text-field>
                     </v-col>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="6" lg="4">
                  <date-time-picker :label="$t('message.advancedWeldLog.weldEnd')" v-model="weld_row.weld_end" clearable prepend-inner-icon="mdi-calendar" :menu-props="{ contentClass: 'weld-end-calendar'}"></date-time-picker>
                </v-col>
                <v-col cols="12"
                       class="d-flex flex-row flex-wrap pa-0">
                  <v-col cols="3" md="4">
                    <v-text-field :label="$t('message.advancedWeldLog.ndt')" disabled value="VT" outlined
                                  hide-details
                                  dense></v-text-field>
                  </v-col>
                  <v-col cols="3" md="4">
                    <v-text-field disabled aria-valuemin="1" aria-valuemax="100" outlined
                                  placeholder="%" v-model="weld_row.vt_scope" type="number" hide-details dense
                                  label="%"></v-text-field>
                  </v-col>
                  <v-col cols="6" md="4">
                    <v-text-field outlined :value="weld_row.vt_sign" hide-details dense
                                  :label="$t('message.advancedWeldLog.sign')">
                      <template #append>
                        <button type="button" @click="signNdtType">
                          <v-icon :color="!weld_row.vt_sign ? 'red': 'green'">
                            mdi-check
                          </v-icon>
                        </button>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-textarea hide-details v-model="weld_row.comments" :label="$t('message.advancedWeldLog.comments')"
                              outlined rows="3"></v-textarea>
                </v-col>
              </v-col>
              <v-col cols="12" class="d-flex flex-row flex-wrap pa-0">
                <v-col cols="6" class="d-flex justify-center">
                  <v-btn :disabled="!computedWPS.length" @click="openPreviewModal('WPS')" plain class="text-none d-flex flex-grow-1 blue lighten-4 weldlog-link-btn"
                         rounded>
                    <v-icon left small>mdi-link</v-icon>
                    {{$t('message.advancedWeldLog.wps')}}<span v-if="weld_row.wps_nr" class="ml-1 text-truncate">- ({{ weld_row.wps_nr }})</span>
                  </v-btn>
                </v-col>
                <v-col @click="openPreviewModal('drawings')" cols="6" class="d-flex justify-center">
                  <v-btn :disabled="!drawing.documents.length" plain class="text-none d-flex flex-grow-1 blue lighten-4 weldlog-link-btn" rounded>
                    <v-icon left small>mdi-link</v-icon>
                    {{$t('message.advancedWeldLog.drawing')}}<span v-if="drawing.drawning_nr" class="ml-1 text-truncate">- ({{ drawing.drawning_nr }})</span>
                  </v-btn>
                </v-col>
              </v-col>
              <v-col cols="12" class="d-flex flex-column flex-wrap">
                <input
                  type="file"
                  ref="fileInput"
                  class="d-none"
                  @change="handleFileUpload"
                />
                <v-btn type="button" @click="$refs.fileInput.click()" plain
                       class="text-none d-flex flex-grow-1 blue lighten-4 weldlog-link-btn" rounded>
                  <v-icon left small>mdi-file-upload-outline</v-icon>
                  Upload Document
                </v-btn>
                <v-list dense class="mt-3">
                  <v-list-item
                    v-for="(file, index) in weld_row.files"
                    :key="index"
                    class="d-flex justify-space-between align-center"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="text-truncate">{{ file.name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-btn small icon @click="removeFile(index)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" class="d-flex flex-row justify-space-between">
                <v-btn class="text-none" type="button" color="error" @click="closeDialog">
                  {{ $t('message.advancedWeldLog.cancel') }}
                </v-btn>
                <v-btn class="text-none" :loading="create_loading" :disabled="create_loading" color="primary"
                       @click="submitForm">
                  {{ $t('message.advancedWeldLog.submit') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- 5183 / R-2.7d: this list can only EDIT — submitForm() requires
         weld_row.id and there is no create action, so a welder who works from
         the list rather than the map cannot register a field weld at all.

         The button routes to the weld-mapping screen for the selected drawing,
         where that flow already lives, rather than adding a second copy of it
         here. A field weld is a quality record with its own rules — the A-number
         naming, the WPS deviation check, the office gate — and two
         implementations of that would drift. -->
    <div v-if="selectedDrawing.id && weldMappingAvailable" class="d-flex justify-end mb-2">
      <v-btn small outlined color="primary" class="text-none" @click="openWeldMapping">
        <v-icon left small>mdi-plus</v-icon>
        {{ $t('message.advancedWeldLog.addFieldWeld') }}
      </v-btn>
    </div>

    <v-menu
      bottom
      v-model="menu"
      :close-on-content-click="false"
      :nudge-bottom="50"
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          outlined
          :value="selectedDrawing.name"
          :label="$t('message.advancedWeldLog.selectDrawing')"
          readonly
          v-bind="attrs"
          v-on="on"
          append-icon="mdi-menu-down"
          dense
          @click:append="on.click"
        ></v-text-field>
      </template>
      <v-card>
        <div>
          <v-text-field
            v-model="treeSearch"
            :label="$t('message.advancedWeldLog.searchDrawings')"
            prepend-inner-icon="mdi-magnify"
            dense
            clearable
            class="px-4 mt-2"
            hide-details
            outlined
            rounded
          />
          <v-treeview
            :search="treeSearch"
            :items="treeData"
            :active.sync="active"
            activatable
            open-all
            item-key="id"
            item-text="name"
            item-children="children"
            class="treeview-projects"
            dense
          >
            <template #prepend="{ item }">
              <a
                href="javascript:void(0)"
                :style="{ cursor: item.data && item.data.has_weldlog === 1 ? 'pointer' : 'not-allowed'}"
                :class="{ 'text--disabled': !item.data || item.data.has_weldlog !== 1 }"
                @click.stop="item.data && item.data.has_weldlog && selectItem(item)"
                class="text-decoration-none text--black d-flex flex-row flex-grow-1 tree-label"
              >
                <weld-icon v-if="item.icon === 'weld_icon'">mdi-wrench</weld-icon>
                <v-icon v-else-if="item.type === 'folder'" size="34" >mdi-folder</v-icon>
                <v-icon v-else>mdi-file</v-icon>
              </a>
            </template>
            <template #label="{ item }">
              <a
                href="javascript:void(0)"
                :style="{ cursor: item.data && item.data.has_weldlog === 1 ? 'pointer' : 'not-allowed'}"
                :class="{ 'text--disabled': !item.data || item.data.has_weldlog !== 1 }"
                @click.stop="item.data && item.data.has_weldlog && selectItem(item)"
                class="text-decoration-none text--black d-flex flex-row flex-grow-1 tree-label"
              >
                {{ item.name }}
              </a>
            </template>
          </v-treeview>
        </div>
      </v-card>
    </v-menu>
    <v-col cols="12" class="pa-0 d-flex flex-row align-content-center justify-space-between mb-3">
      <v-text-field
        v-model="search"
        :label="$t('message.advancedWeldLog.searchWeldLogs')"
        prepend-inner-icon="mdi-magnify"
        dense
        clearable
        class="mb-2"
        hide-details
        outlined
        rounded
      />
    </v-col>
    <v-data-table
      :no-data-text="!selectedDrawing.id ? $t('message.advancedWeldLog.selectDrawingToLoadWeldLogs') :  $t('message.advancedWeldLog.noWeldLogResultsFound')"
      :loading="loading"
      :search="search"
      disable-sort
      :headers="tableHeaders"
      :items="weld_logs"
      :items-per-page="20"
      :item-class="getWeldlogRecordBgByStatus"
      class="elevation-1"
      @click:row="editWeldLogEntry"
    >
    </v-data-table>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import WeldIcon from '@/components/WeldIcon.vue'
import PdfViewer from '@/components/PdfViewer/PdfViewer.vue'
import DateTimePicker from '@/components/DateTimePicker.vue'
import DocumentGalleryMixin from '@/mixins/documentGallery'
import { checkWeldMappingPermission } from '@/router'
export default {
  mixins: [DocumentGalleryMixin],
  components: {
    PdfViewer,
    DateTimePicker,
    WeldIcon
  },
  mounted () {
    this.$store.commit('advancedWeldLog/resetState')
    this.selectedDrawing = {}
    this.active = []
    this.getDrawingsFolderList({
      project_id: this.$route.params.project_id
    }).then(() =>{
       if(this.$route.params.drawing_id){
        this.active = [this.$route.params.drawing_id]
        this.getDrawing({
          drawing_id: this.$route.params.drawing_id
        }).then(() => {
           this.selectedDrawing = {
            id: this.drawing.id,
            name: this.drawing.drawning_nr
          }
          this.getProjectWeldLogs({
            drawing_id: this.drawing.id
          })
        })
      }
    })
    this.getExpertise({})
  },
  data () {
    return {
      expertiseSearch: '',
      treeSearch: '',
      menu: false,
      active: [],
      selectedDrawing: {},
      user: JSON.parse(this.$cookie.get('WELDIT_PWA_user')),
      search: '',
      weld_row: {
        charge_nr: null,
        wps_nr: null,
        vt_scope: 100,
        vt_sign: null,
        filler_materials: null,
        comments: null,
        welding_process: null,
        welding_compound: {},
        weldlog_expertise_id: [],
        weld_end: null,
        files: []
      },
      new_weld_dialog: false,
      headers: [
        {
          text: this.$t('message.advancedWeldLog.weldNo'),
          value: 'weld_nr'
        },
        {
          text: this.$t('message.advancedWeldLog.jointType'),
          value: 'welding_compound.name'
        },
        {
          text: this.$t('message.advancedWeldLog.weldingProcess'),
          value: 'welding_process'
        }
      ],
      // 5183 / R-2.7c: with a production series the same weld number appears
      // once per unit, so a list without the spool showed "W-0001" three times
      // and the welder could not tell which unit they were signing. The API has
      // sent spool_no since PRODSERIES Phase 6 — only the column was missing.
      // Added dynamically (computed `tableHeaders`) so a project without a
      // series still gets exactly today's three columns.
      create_loading: false
    }
  },
  watch: {
    expertiseSearch(val){
      this.getExpertise({
        name: val,
        valid_on: this.expertiseValidOn
      })
    },
    expertiseValidOn (val) {
      this.getExpertise({
        name: this.expertiseSearch,
        valid_on: val
      })
    },
    selectedDrawing (val) {
      if (val.id) {
        this.getDrawing({
          drawing_id: val.id
        }).then(() => {
          this.getProjectWeldLogs({
            drawing_id: this.drawing.id
          })
        })
      } else {
        this.$store.commit('advancedWeldLog/setWeldLogs', [])
      }
    }
  },
  computed: {
    expertiseValidOn () {
      const day = String(this.weld_row.weld_end || '').slice(0, 10)
      return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : null
    },
    /**
     * Table columns, with the spool/part column only when the rows carry one
     * (5183 / R-2.7c).
     *
     * A production series repeats the drawing's weld set per unit, so the same
     * weld number appears once per unit and a list without the spool is
     * ambiguous — "W-0001" three times, and the welder cannot tell which unit
     * they are signing. Driven off the data rather than off a feature flag, so
     * a project with no series is unchanged.
     */
    /**
     * Whether the weld-mapping screen is reachable for this user (5183 / R-2.7d).
     * Same check the router's guard uses, so the button never offers a route
     * the guard would bounce.
     */
    weldMappingAvailable () {
      try {
        return checkWeldMappingPermission()
      } catch (e) {
        return false
      }
    },
    tableHeaders () {
      const hasSpool = (this.weld_logs || []).some(r => r && String(r.spool_no || '').trim() !== '')
      if (!hasSpool) return this.headers
      const out = this.headers.slice()
      out.splice(1, 0, {
        text: this.$t('message.advancedWeldLog.spoolNo'),
        value: 'spool_no'
      })
      return out
    },
    ...mapGetters({
      loading: 'advancedWeldLog/loading',
      weld_logs: 'advancedWeldLog/weld_logs',
      drawing: 'advancedWeldLog/drawing',
      expertise: 'advancedWeldLog/expertise',
      drawings_folder_list: 'advancedWeldLog/drawings_folder_list'
    }),
    computedWPS(){
      const wpsNrList = this.weld_row.wps_nr
        ? this.weld_row.wps_nr.replace(/, /g, ",").split(",")
        : [];
      return this.drawing.project.wps.filter(k => wpsNrList.includes(k.wps_number));
    },
    computedNdtSpecification () {
      return this.weld_logs?.[0]?.ndt_specification ?? 'N/A'
    },
    treeData () {
      // If it's empty or not ready
      if (!this.drawings_folder_list || Object.keys(this.drawings_folder_list).length === 0) {
        return []
      }

      const transformNode = (node) => {
        return {
          id: node?.data?.id ?? node.text,
          name: node.text ?? '',
          type: node.type,
          icon: node.icon,
          data: node.data,
          children: (node.children || []).map(transformNode)
        }
      }

      return [transformNode(this.drawings_folder_list)]
    }
  },
  methods: {
    ...mapActions({
      getDrawing: 'advancedWeldLog/getDrawing',
      getProjectWeldLogs: 'advancedWeldLog/getProjectWeldLogs',
      getExpertise: 'advancedWeldLog/getExpertise',
      updateWeldLog: 'advancedWeldLog/updateWeldLog',
      getDrawingsFolderList: 'advancedWeldLog/getDrawingsFolderList'
    }),
    getFileExtension (filename) {
      return filename.split('.').pop().toLowerCase()
    },
    getWeldlogRecordBgByStatus (item) {
      return item.welding_status == 1 ? 'weldlog-pending-status' : 
      item.welding_status == 2 ? 'weldlog-ready-status' :
      item.welding_status == 3 ? 'weldlog-finished-status' : '';
    },
    selectItem (item) {
      this.active = [item.id]
      this.selectedDrawing = item
      this.menu = false
    },
    signNdtType () {
      this.weld_row.vt_sign = moment().format('DD.MM.YYYY') + ` ${this.user.initialer}`
    },
    resetForm () {
      this.weld_row = {
        charge_nr: null,
        wps_nr: null,
        vt_scope: 100,
        vt_sign: null,
        filler_materials: null,
        comments: null,
        welding_process: null,
        welding_compound: {},
        weldlog_expertise_id: [],
        weld_end: null,
        wps:{
          documents: []
        },
        files: []
      }
    },
    editWeldLogEntry (item) {
      let formattedDate = null
      if (item.weld_end) {
        /* 5183 / R-2.7b: moment.parseZone KEEPS the incoming offset, and the
           API serialises weld_end as UTC ("2026-09-27T15:19:47Z"), so the field
           showed 15:19 where the PC — and the database, which stores Europe/Oslo
           wall time — say 17:19. Two hours early, every time, on a field the
           welder signs.

           Plain moment() converts a zoned string to the device's own zone and
           leaves a zone-less one alone, which is the right answer for both an
           ISO-Z value and an older server's bare datetime. The submit side sends
           local wall time back and Laravel parses it in the app timezone, so the
           round trip closes. */
        formattedDate = moment(item.weld_end).format('YYYY-MM-DDTHH:mm')
      }
      this.weld_row = Object.assign(this.weld_row, {
        ...item,
        weld_end: formattedDate,
        weldlog_expertise_id: (item.weldlog_expertise_id || '').split(',').map(k => parseInt(k)).filter(k => !isNaN(k)),
      }, {})
      this.new_weld_dialog = true
    },
    /** Open the weld-mapping screen for the selected drawing (5183 / R-2.7d). */
    openWeldMapping () {
      this.$router.push({
        name: 'weld-mapping-drawing',
        params: {
          project_id: this.$route.params.project_id,
          drawing_id: this.selectedDrawing.id
        }
      }).catch(() => {})
    },
    submitForm () {
      if (this.$refs.weldForm.validate()) {
        const formData = new FormData()

        // Map welder IDs from expertise IDs
        const welderIds = this.weld_row.weldlog_expertise_id
          .map(id => {
            const row = this.expertise.find(x => Number(x.expertise_id) === Number(id));
            return row?.welder_id || '';
          })
          .filter(Boolean)
          .join(',');
        
        formData.append('id', this.weld_row.id)
        formData.append('weld_end', this.weld_row.weld_end ?? '')
        formData.append('charge_nr', this.weld_row.charge_nr ?? '')
        formData.append('weldlog_expertise_id', this.weld_row.weldlog_expertise_id.join(',') ?? '')
        formData.append('welding_id', welderIds ?? '')
        formData.append('vt_scope', this.weld_row.vt_scope ?? '')
        formData.append('vt_sign', this.weld_row.vt_sign ?? '')
        formData.append('comments', this.weld_row.comments ?? '')
        formData.append('_method', 'PUT')

        // Append uploaded files
        this.weld_row.files.forEach((file, index) => {
          formData.append(`files[${index}]`, file)
        })

        this.create_loading = true

        if (this.weld_row.id) {
          this.updateWeldLog(formData).then((res) => {
            this.create_loading = false
            this.new_weld_dialog = false
            this.resetForm()
            this.getProjectWeldLogs({
              drawing_id: this.drawing.id
            })
            this.$root.$emit('snackbar', {
              snackbar: true,
              color: 'success',
              text: res.data.message
            })
          }).catch((err) => {
            console.log(err.response)
            this.create_loading = false
            this.$root.$emit('snackbar', {
              snackbar: true,
              color: 'error',
              text: err.response?.data?.message || 'An error occurred'
            })
          })
        }
      }
    },
    closeDialog () {
      this.new_weld_dialog = false
      this.resetForm()
    },
    handleFileUpload (event) {
      const file = event.target.files[0]
      if (file) {
        this.weld_row.files.push(file)
      }
    },
    removeFile (index) {
      this.weld_row.files.splice(index, 1)
    },
    openPreviewModal (type) {
      let docs = []
      if (type === 'drawings') {
        docs = this.drawing.documents.map((k) => ({
          downloadUrl: k.download_url,
          extention: this.getFileExtension(k.original_name || ''),
          original_name: k.original_name
        }))
      } else {
        docs = this.computedWPS.map((k) => ({
          downloadUrl: k.download_url,
          extention: 'pdf',
          original_name: k.wps_number
        }))
      }
      const imageExt = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp']
      const pdfThumb = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect width="80" height="80" fill="#2b2b2b"/><rect x="18" y="10" width="44" height="60" rx="3" fill="#e53935"/><text x="40" y="48" font-family="Arial,Helvetica,sans-serif" font-size="16" font-weight="bold" fill="#fff" text-anchor="middle">PDF</text></svg>')
      const galleryItems = docs
        .filter(d => d.downloadUrl && (imageExt.includes(d.extention) || d.extention === 'pdf'))
        .map(d => {
          const title = d.original_name || ''
          if (imageExt.includes(d.extention)) {
            return { src: d.downloadUrl, thumb: d.downloadUrl, subHtml: `<h4>${title}</h4>` }
          }
          // Render the PDF straight in the iframe. Google's embedded viewer needs a
          // publicly reachable URL — our downloadUrl is host/auth-scoped, so Google's
          // fetch fails and the slide shows "No preview available".
          return { src: d.downloadUrl, iframe: true, thumb: pdfThumb, subHtml: `<h4>${title}</h4>` }
        })
      if (!galleryItems.length) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'warning', text: 'message.customModule.urlNotFound' })
        return
      }
      this.openGallery(galleryItems)
    }
  }
}
</script>
<style>
/* Small screens (phones) */
@media (max-width: 600px) {
  .weld-end-calendar {
    left: auto !important;
    right: 10px !important;
    max-width: 100% !important;
  }
}

.v-treeview-node .mdi-menu-down,
.v-treeview-node__toggle .v-icon,
.v-treeview-node__toggle i {
  font-size: 52px !important;
  width: 30px !important;
  height: 30px !important;
  margin-right: 5px !important;
}
.treeview-projects .v-treeview-node__children {
  max-height: 350px;
  overflow-y: auto;
  padding-bottom: 18px;
}
</style>